// extracted by mini-css-extract-plugin
export default {"heroSec_inner":"heroSec_heroSec_inner__ujd7u","heroSec_headerP":"heroSec_heroSec_headerP__Ocgki"};